export const TOGGLE_SRP_BUS_LOADING = 'TOGGLE_SRP_BUS_LOADING';
export const UPDATE_SRP_BUS_DATA = 'UPDATE_SRP_BUS_DATA';
export const UPDATE_RTC_VIEW = 'UPDATE_RTC_VIEW';
export const UPDATE_SORTBY = 'UPDATE_SORTBY';
export const RESET_FILTERS = 'RESET_FILTERS';
export const FILTER_COLLAPSE = 'FILTER_COLLAPSE';
export const UPDATE_ACTIVE_SEARCH_FILTER = 'UPDATE_ACTIVE_SEARCH_FILTER';
export const UPDATE_SELECTED_FILTER = 'UPDATE_SELECTED_FILTER';
export const UPDATE_SELECTED_BUS ='UPDATE_SELECTED_BUS'
export const UPDATE_GO_SAFE_BANNER ="SRP/UPDATE_GO_SAFE_BANNER";
export const UPDATE_ROUTE_ID = "SRP/UPDATE_ROUTE_ID";
export const TOGGLE_ALTERNATE_ROUTE_PAGE="SRP/TOGGLE_ALTERNATE_ROUTE_PAGE";
export const SET_NEXT_DAY_POPUP = "SRP/SET_NEXT_DAY_POPUP";
export const SET_SRP_CARD_INDEX = "SET_SRP_CARD_INDEX";